import { useEffect } from "react";
import { useQuery, skipToken } from "@tanstack/react-query";
import { z } from "zod";
import { authApi } from "@/services/api/client";
import { ApiError } from "@/types/api";
import { useAuth } from "./useAuth";
import { authSession } from "../store/useAuthStore";

const titleSchema = z.object({
  tenantId: z.uuid(),
  adminTitle: z.string().max(128).nullable(),
});
/** One cached lookup on school selection/chooser entry, with no continuous polling. */
export function useAdminTitleRefresh() {
  const { requestScope: scope, isAdmin } = useAuth();
  const query = useQuery({
    queryKey: [
      "admin-title",
      scope?.personId,
      scope?.tenantId,
      scope?.generation,
    ],
    queryFn:
      scope?.tenantId && isAdmin
        ? async ({ signal }) => {
            const result = titleSchema.parse(
              await authApi.adminTitle({ requestScope: scope, signal }),
            );
            if (result.tenantId.toLowerCase() !== scope.tenantId?.toLowerCase())
              throw new ApiError("invalid-response");
            return result;
          }
        : skipToken,
    staleTime: 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  });
  useEffect(() => {
    if (query.data && scope)
      authSession.updateAdminTitle(scope, query.data.adminTitle);
  }, [query.data, scope]);
}
